import { useMemo } from 'react';
import { useOrganizationSettings } from './useOrganizationSettings';

export type PaymentMode = 'swift_direct' | 'gateway' | 'manual';

export interface PaymentFlowConfig {
  hasSwiftAccountId: boolean;
  swiftAccountId: string | null;
  paymentMode: PaymentMode;
  shouldSkipPayment: boolean;
  isLoading: boolean;
}

export const usePaymentFlowConfig = (): PaymentFlowConfig => {
  const { getSetting, loading } = useOrganizationSettings();
  
  const swiftAccountId = getSetting('send_swift_account_id');
  const hasSwiftAccountId = !!swiftAccountId;

  const paymentMode: PaymentMode = useMemo(() => {
    if (hasSwiftAccountId) {
      return 'swift_direct';
    }
    // Future: Check for payment gateway settings
    // const gatewayProvider = getSetting('payment_gateway_provider');
    // if (gatewayProvider) return 'gateway';
    
    return 'manual';
  }, [hasSwiftAccountId]);

  return {
    hasSwiftAccountId,
    swiftAccountId,
    paymentMode,
    shouldSkipPayment: hasSwiftAccountId,
    isLoading: loading,
  };
};
